module.exports = __webpack_public_path__ + "static/media/offline1.121b347f.jpg";